import { Link } from 'react-router-dom';

export default function Footer() {
  const whatsappNumber = '56942470111';
  const whatsappMessage = encodeURIComponent('Hola, me interesa conocer más sobre sus servicios de hosting.');

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-gray-300 pt-12 sm:pt-16 pb-8 px-4 sm:px-6">
      {/* Top Banner */}
      <div className="max-w-7xl mx-auto mb-10 sm:mb-12">
        <div className="bg-gradient-to-r from-blue-600 to-cyan-600 rounded-2xl p-6 sm:p-8 flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6">
          <div className="text-center md:text-left">
            <h3 className="text-white text-xl sm:text-2xl font-bold mb-1">¿Listo para comenzar?</h3>
            <p className="text-blue-100 text-sm">Migración gratuita · SSL incluido · Soporte 24/7 en español</p>
          </div>
          <div className="flex gap-3 flex-wrap justify-center">
            <Link
              to="/contratar"
              className="bg-white text-blue-600 px-5 sm:px-6 py-2.5 sm:py-3 rounded-xl font-bold hover:bg-blue-50 transition-all whitespace-nowrap shadow-lg text-sm sm:text-base"
            >
              Contratar Ahora
            </Link>
            <a
              href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
              target="_blank"
              rel="nofollow noreferrer"
              className="bg-green-500 text-white px-5 sm:px-6 py-2.5 sm:py-3 rounded-xl font-bold hover:bg-green-600 transition-all whitespace-nowrap flex items-center gap-2 shadow-lg text-sm sm:text-base"
            >
              <i className="ri-whatsapp-line text-lg sm:text-xl"></i>
              WhatsApp
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-6 sm:gap-8 mb-10 sm:mb-12">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-2">
            <img
              src="https://static.readdy.ai/image/be576f6491539e09547f155b96a8505c/654d7271eebe648b023e28c3cac0cad0.png"
              alt="EhostingChile.cl"
              className="h-8 sm:h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm leading-relaxed mb-2 text-gray-400">
              Ehosting Chile es parte de Agencia Visual Chile, Hosting, VPS, servidores en Chile, EEUU y Europa; con soporte local desde 2006.
            </p>
            <div className="flex items-center gap-2 mb-4 sm:mb-5">
              <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
              <span className="text-xs text-green-400 font-semibold">Todos los sistemas operativos</span>
            </div>
            <div className="flex space-x-2 sm:space-x-3">
              <a href="#" rel="nofollow" className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-gray-800 rounded-full hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-gray-800 rounded-full hover:bg-pink-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-gray-800 rounded-full hover:bg-gray-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-gray-800 rounded-full hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
              <a
                href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
                target="_blank"
                rel="nofollow noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-gray-800 rounded-full hover:bg-green-600 transition-colors cursor-pointer"
                title="Contáctanos por WhatsApp"
              >
                <i className="ri-whatsapp-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Servicios */}
          <div>
            <h3 className="text-white font-bold mb-3 sm:mb-4 text-xs sm:text-sm uppercase tracking-wider">Servicios</h3>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li><Link to="/hosting" className="hover:text-blue-400 transition-colors cursor-pointer">Hosting Web</Link></li>
              <li><Link to="/vps" className="hover:text-blue-400 transition-colors cursor-pointer">VPS Chile</Link></li>
              <li><Link to="/dominios" className="hover:text-blue-400 transition-colors cursor-pointer">Registro Dominios</Link></li>
              <li><Link to="/servicios" className="hover:text-blue-400 transition-colors cursor-pointer">Email Corporativo</Link></li>
            </ul>
          </div>

          {/* Soporte */}
          <div>
            <h3 className="text-white font-bold mb-3 sm:mb-4 text-xs sm:text-sm uppercase tracking-wider">Soporte</h3>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li><Link to="/soporte" className="hover:text-blue-400 transition-colors cursor-pointer">Centro de Ayuda</Link></li>
              <li><Link to="/soporte" className="hover:text-blue-400 transition-colors cursor-pointer">Abrir Ticket</Link></li>
              <li><Link to="/blog" className="hover:text-blue-400 transition-colors cursor-pointer">Documentación</Link></li>
              <li><Link to="/contratar" className="hover:text-blue-400 transition-colors cursor-pointer">Contacto</Link></li>
            </ul>
          </div>

          {/* Contacto */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-white font-bold mb-3 sm:mb-4 text-xs sm:text-sm uppercase tracking-wider">Contacto</h3>
            <ul className="space-y-3 text-xs sm:text-sm">
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-blue-400 mt-0.5 flex-shrink-0"></i>
                <span>+56 2 2581 9100</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-blue-400 mt-0.5 flex-shrink-0"></i>
                <span>soporte@ehostingchile.com</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-blue-400 mt-0.5 flex-shrink-0"></i>
                <span>Av. Apoquindo 6410, of 202, Las Condes, Santiago, Chile</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-time-line text-blue-400 mt-0.5 flex-shrink-0"></i>
                <span>Soporte 24/7</span>
              </li>
              <li>
                <a
                  href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 mt-1 bg-green-600 hover:bg-green-500 text-white px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-semibold transition-colors whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  Escribir por WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="border-t border-gray-800 pt-6 sm:pt-8 pb-4 sm:pb-6">
          <div className="flex flex-wrap justify-center gap-3 sm:gap-6 mb-6 sm:mb-8">
            {[
              { icon: 'ri-shield-check-line', label: 'SSL Gratuito', color: 'text-green-400' },
              { icon: 'ri-dashboard-3-line', label: 'cPanel Partner', color: 'text-blue-400' },
              { icon: 'ri-cloud-line', label: 'CloudLinux', color: 'text-orange-400' },
              { icon: 'ri-flashlight-line', label: 'LiteSpeed', color: 'text-yellow-400' },
              { icon: 'ri-global-line', label: 'Tráfico Ilimitado', color: 'text-cyan-400' },
              { icon: 'ri-lock-2-line', label: 'Pago Seguro', color: 'text-emerald-400' },
            ].map((badge, i) => (
              <div key={i} className="flex items-center gap-1.5 sm:gap-2 bg-gray-800/60 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full">
                <i className={`${badge.icon} ${badge.color} text-sm sm:text-base`}></i>
                <span className="text-xs text-gray-300 font-medium">{badge.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-gray-800 pt-5 sm:pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0 gap-4">
            <p className="text-xs sm:text-sm text-gray-500 text-center md:text-left">
              © 2026 EhostingChile.com · Hosting profesional en Chile desde 2006 · Es parte de <a href="https://www.visualchile.cl" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 transition-colors">Visual Chile</a>
            </p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-xs sm:text-sm">
              <Link to="/terminos" className="text-gray-500 hover:text-blue-400 transition-colors cursor-pointer">
                Términos de Servicio
              </Link>
              <Link to="/privacidad" className="text-gray-500 hover:text-blue-400 transition-colors cursor-pointer">
                Política de Privacidad
              </Link>
              <a href="#" rel="nofollow" className="text-gray-500 hover:text-blue-400 transition-colors cursor-pointer">
                SLA
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}